import React, { Component } from "react";

import HeaderVertical from "./../common/header-vertical.js";

// import FeedbackRatingModal from "./../common/modal/feedback-rating";

import { scrollToTop } from "./../../helpers/screen";

export default class Wide extends Component {
    componentDidMount() {
        scrollToTop();
    }

    render() {
        const { id, dark = true, children = "", type = false, extensions = false } = this.props;
        let { className = [] } = this.props;

        className.unshift("layout-wide");
        if (type) {
            className.push(type);
        }

        return (
            <div id={id} className={className.join(" ")}>
                <div id="page-top"></div>
                <div className={`content-container ${type}`}>
                    <aside>
                        <HeaderVertical darkmode={dark} type={type} extensions={extensions} />
                    </aside>
                    <main>{children}</main>
                </div>
                {/*<FeedbackRatingModal page="SignUp" />*/}
            </div>
        );
    }
}
